import { useRef, useState } from "react";
import api, { fileUrl } from "@/lib/api";
import { ImagePlus, Loader2, X } from "lucide-react";

export const ImageUpload = ({ value, onChange, testid = "image-upload", onUploadStateChange }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    onUploadStateChange?.(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const res = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(res.data.path);
    } catch (err) {
      console.error(err);
    } finally {
      setUploading(false);
      onUploadStateChange?.(false);
    }
  };

  return (
    <div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid={`${testid}-input`} />
      {value ? (
        <div className="relative rounded-2xl overflow-hidden border border-stone-200 group">
          <img src={fileUrl(value)} alt="cover" className="w-full h-40 object-cover" />
          <button
            type="button"
            onClick={() => onChange(null)}
            data-testid={`${testid}-remove`}
            className="absolute top-2 right-2 bg-white/90 hover:bg-white rounded-full p-1.5 shadow"
          >
            <X className="w-4 h-4 text-stone-700" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          data-testid={`${testid}-btn`}
          className="w-full h-40 rounded-2xl border-2 border-dashed border-stone-300 hover:border-ac hover:bg-ac-soft/50 transition-all flex flex-col items-center justify-center gap-2 text-stone-400 hover:text-ac"
        >
          {uploading ? <Loader2 className="w-6 h-6 animate-spin" /> : <ImagePlus className="w-6 h-6" strokeWidth={2.5} />}
          <span className="text-sm font-semibold">{uploading ? "Uploading…" : "Add cover image"}</span>
        </button>
      )}
    </div>
  );
};
